{
  "schemaVersion": "cogo.document-template-family.v2",
  "familyId": "reb-report",
  "familyVersion": "1.0.0",
  "name": "부동산원 보고서",
  "description": "표지·목차·요약·본문·부록 5부 구성 부동산원(REB) project-scope 보고서 템플릿 패밀리. 문서 DS(@ds:document.reb-report.v1)를 designTokenRefs로 참조한다. 부동산원 지가동향(land-price) 및 상업용임대동향(commercial-rent) DocumentModel의 NativeWriterDocumentModelSchema 정합 판정(receipt: docs/ontology/evidence/reb-document-ontology-conformance-2026-08-24/receipt.json)은 두 모델 모두 classification=\"structural\"(필드 형태의 구조적 불일치이며 값 자체의 의미적 오류가 아님)로 측정되었으며, 이 project-scope 특수화는 그 측정 결과를 근거로 한다. 위 두 DocumentModel은 이전에 semanticCore.sourceProvenance.sourceRefs에 content-addressed ref로 선언돼 있었으나, 컴파일러(resolveFamilyResourceArtifacts)는 sourceRefs의 각 항목에 대해 정확한 아티팩트 바이트를 요구하고 이 패밀리에는 그 바이트를 공급할 합법적 채널이 없다(legacyTemplateRefs·semanticCore.assets가 모두 비어 있고, input.schema.json이 additionalProperties:false인 closed schema로 evidenceRef를 선언하지 않아 semanticEvidence 집합이 필연적으로 공집합이다). 따라서 sourceRefs는 컴파일러가 실제로 바인딩하는 두 아티팩트(input.schema.json, flow-page.v1.json)로 재지정했다. sourceProvenance는 네 개 키만 허용하므로 물러난 두 ref를 옮겨 담을 필드가 없어, 그 content-addressed 정체성을 여기에 보존한다 — 이는 출처 기록(provenance record)이며 컴파일러가 해소하는 참조가 아니다: docs/agentic/evidence/cogo-document-export-production/cogo-document-model.normalized.v1.json#sha256:b38bf3337ecfb216cc434190d5fe11e84c45690740cf1efbed390652be12a04e , docs/agentic/evidence/cogo-document-export-production-commercial-rent/cogo-document-model.normalized.v1.json#sha256:25a3a10a179799c3146ababa1379d0ba5b9b5e00a8dbcd99dc2340b6d2760156 . 두 digest는 위 receipt의 inputs.landPriceModel·inputs.commercialRentModel에도 path와 함께 기록돼 있으며, reb-report-family.test.ts가 이 문장에서 두 값을 추출해 저장소의 실제 파일 바이트로 재계산·대조한다.",
  "metadata": {
    "ownerRef": "project://reb",
    "locale": "ko-KR",
    "tags": [
      "reb",
      "project-template",
      "document-ontology"
    ]
  },
  "legacyTemplateRefs": [],
  "semanticCore": {
    "dataSchema": {
      "ref": "input.schema.json",
      "sha256": "sha256:33b281eac81c6da2265471822a10a027fb35ffac33784c5d6258d91bd0285130"
    },
    "slots": [
      {
        "id": "cover",
        "kind": "rich-text",
        "bindingPath": "/cover",
        "required": true,
        "semanticRole": "cover"
      },
      {
        "id": "toc",
        "kind": "table",
        "bindingPath": "/toc",
        "required": true,
        "semanticRole": "toc"
      },
      {
        "id": "summary",
        "kind": "rich-text",
        "bindingPath": "/summary",
        "required": true,
        "semanticRole": "summary"
      },
      {
        "id": "body",
        "kind": "rich-text",
        "bindingPath": "/body",
        "required": true,
        "semanticRole": "body"
      },
      {
        "id": "appendix",
        "kind": "rich-text",
        "bindingPath": "/appendix",
        "required": true,
        "semanticRole": "appendix"
      }
    ],
    "tokens": {
      "designTokenRefs": [
        "@ds:document.reb-report.v1"
      ]
    },
    "assets": [],
    "guidelineRefs": [
      {
        "ref": "guideline://cogo/document-template-quality/v2",
        "required": true
      }
    ],
    "llmPolicy": {
      "allowedRoles": [
        "semantic-input-assistant",
        "layout-proposal-assistant",
        "content-revision-assistant"
      ],
      "canonicalAuthority": false,
      "finalWriterAllowed": false,
      "outputRequiresValidation": true
    },
    "actionFlowRefs": [
      {
        "id": "generate-document",
        "ref": "actionflow://document-template/generate/v1",
        "role": "generation"
      },
      {
        "id": "approve-document",
        "ref": "actionflow://document-template/approve/v1",
        "role": "approval"
      },
      {
        "id": "publish-document",
        "ref": "actionflow://document-template/publish/v1",
        "role": "publication"
      }
    ],
    "proofProfile": {
      "requiredForPromotion": true,
      "nativeStructureReadbackRequired": true,
      "targetReadbackRequired": true,
      "structureHashRequired": true,
      "providerVersionPolicy": "required-when-provider",
      "visualDiffPolicy": "when-layout-bearing",
      "evidenceRetention": "immutable"
    },
    "sourceProvenance": {
      "required": true,
      "sourceRefs": [
        "input.schema.json",
        "flow-page.v1.json"
      ],
      "preserveProviderVersion": true,
      "sourceAdaptersCanonical": false
    }
  },
  "promotionPolicy": {
    "humanPromotionRequired": true,
    "automatedPromotionAllowed": false,
    "modelMayApprove": false,
    "evidenceRequired": true
  },
  "variants": [
    {
      "variantId": "flow-page-reb-report",
      "name": "Flow Page REB Report",
      "layoutProfile": "flow-page",
      "capabilityStatus": "partial",
      "knownLimitations": [
        "WordGard edits narrative nodes only; complex tables, charts, and package layout remain adapter-owned.",
        "Google Docs requires a configured native source document before publication."
      ],
      "layout": {
        "kind": "flow-page",
        "layoutRef": "flow-page.v1.json",
        "layoutSha256": "sha256:400db4ca00550577c710e44221fd52c7c3499906ddd984814e35f2b6a5e150c0",
        "pagination": "flow"
      },
      "sourcePolicy": {
        "canonicalModel": "cogo-document-template-family",
        "editorAdapters": [
          "wordgard",
          "google-docs"
        ],
        "adapterCanonicalAuthority": false
      },
      "slotBindings": [
        {
          "slotId": "cover",
          "bindingRef": "flow-page.v1.json#/slotBindings/0"
        },
        {
          "slotId": "toc",
          "bindingRef": "flow-page.v1.json#/slotBindings/1"
        },
        {
          "slotId": "summary",
          "bindingRef": "flow-page.v1.json#/slotBindings/2"
        },
        {
          "slotId": "body",
          "bindingRef": "flow-page.v1.json#/slotBindings/3"
        },
        {
          "slotId": "appendix",
          "bindingRef": "flow-page.v1.json#/slotBindings/4"
        }
      ],
      "approvedOmissions": [],
      "renderTargets": [
        "docx"
      ],
      "publicationTargets": [],
      "targetOverlays": [
        {
          "target": "docx",
          "adapter": "cogo-document-renderer:docx",
          "canonicalAuthority": false,
          "implementationStatus": "partial",
          "readbackRequired": true,
          "templateMode": "generated-from-cogo"
        }
      ]
    }
  ]
}
